import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { NAV } from '../constants/testIds';
import { useAuth } from '../lib/auth';

const links = [
    { to: '/', label: 'Home', tid: NAV.home },
    { to: '/upcoming', label: 'Upcoming Events', tid: 'nav-upcoming' },
    { to: '/reviews', label: 'Reviews', tid: 'nav-reviews' },
    { to: '/gallery', label: 'Gallery', tid: 'nav-gallery' },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const { user, logout } = useAuth();

    const startLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + '/dashboard';
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <header className="sticky top-0 z-50 glass border-b border-white/10">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 flex items-center justify-between">
                <Link to="/" data-testid={NAV.logo} className="flex items-center gap-3">
                    <div className="relative h-11 w-11 rounded-full overflow-hidden ring-2 ring-[#f7022a]/70 shadow-[0_6px_18px_-4px_rgba(247,2,42,0.55)]">
                        <img
                            src="https://customer-assets.emergentagent.com/job_voyage-party/artifacts/lr2c9gd7_ca01cc42-bf71-45be-98f9-a5b79a25bef9-1.png"
                            alt="Ms. Ruby"
                            className="absolute inset-0 h-full w-full object-cover"
                        />
                    </div>
                    <div className="leading-none">
                        <div className="font-display text-lg sm:text-xl font-extrabold tracking-tight uppercase">
                            Cruise <span className="font-serif-italic font-medium text-brand-gold">Vibes</span>
                        </div>
                        <div className="text-[9px] uppercase tracking-[0.3em] text-white/55 mt-0.5">
                            By <span className="text-brand-ruby font-semibold">Rubies Global Services</span>
                        </div>
                    </div>
                </Link>
                <nav className="hidden lg:flex items-center gap-7">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={l.tid}
                            className={({ isActive }) =>
                                `text-sm tracking-wide transition-colors ${isActive ? 'text-brand-aqua' : 'text-white/75 hover:text-white'}`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="hidden lg:flex items-center gap-3">
                    {user ? (
                        <>
                            {user.role === 'admin' && (
                                <NavLink to="/admin" data-testid={NAV.admin} className="text-xs uppercase tracking-widest text-brand-gold">Admin</NavLink>
                            )}
                            <NavLink to="/dashboard" data-testid={NAV.dashboard} className="text-sm text-white/80 hover:text-white">
                                {user.name?.split(' ')[0] || 'Account'}
                            </NavLink>
                            <button onClick={logout} data-testid={NAV.logout} className="text-xs text-white/50 hover:text-white">Logout</button>
                        </>
                    ) : (
                        <button onClick={startLogin} data-testid={NAV.login} className="text-sm text-white/80 hover:text-white">Sign In</button>
                    )}
                </div>
                <button
                    className="lg:hidden text-white"
                    onClick={() => setOpen((v) => !v)}
                    data-testid={NAV.mobileToggle}
                    aria-label="Toggle menu"
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>
            {open && (
                <div className="lg:hidden border-t border-white/10 px-5 py-4 space-y-3 bg-brand-bg/95">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            onClick={() => setOpen(false)}
                            className="block text-sm text-white/80"
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    {user ? (
                        <>
                            <NavLink to="/dashboard" onClick={() => setOpen(false)} className="block text-sm text-brand-aqua">Dashboard</NavLink>
                            {user.role === 'admin' && <NavLink to="/admin" onClick={() => setOpen(false)} className="block text-sm text-brand-gold">Admin</NavLink>}
                            <button onClick={logout} className="block text-sm text-white/60">Logout</button>
                        </>
                    ) : (
                        <button onClick={startLogin} className="block text-sm text-brand-aqua">Sign In with Google</button>
                    )}
                </div>
            )}
        </header>
    );
}
